const ClassFunc = require('../../util/ClassFunc')
const Common = require('./Common')
const Executor = require('../to/Executor')

const executor = new Executor
/**
 * The Executor class acts as the view object for the executor.
 */
const tbs_model_vo_Executor = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Executor.prototype = {
    /* The view object name */
    name: 'executor',
    /* The view object instance */
    view: {
        invite: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetBMUnionMatchManagerInvitationInfo',
            method: 'get',
            basePath: 'data',
            query: {
                ticket: 'ticket',
            },
            rule: {
                name: 'managerName',
                roleLabel: '$unionMatchId',
                organizationId: 'unionMatchId',
                organizationName: 'unionMatchName',
                organizationLogoUrl: 'unionMatchIcon',
            }
        },
        accept: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AcceptBMUnionMatchManagerInvitation',
            basePath: '',
            rule: {
                ticket: 'ticket',
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderRoleLabel: function() {
        return executor.localeProp('match-executor')
    },
    localeProp: function(key, params) {
        return executor.localeProp(key, params)
    }
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_Executor, Common);

module.exports = tbs_model_vo_Executor